import { render, staticRenderFns } from "./RolesPicker.vue?vue&type=template&id=600ce809&"
import script from "./RolesPicker.vue?vue&type=script&lang=js&"
export * from "./RolesPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports